/* Video section — lazy load Vimeo/YouTube iframes on click */
(function() {
  'use strict';

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-video-play]');
    if (!btn) return;

    var videoId = btn.dataset.videoPlay;
    var platform = btn.dataset.platform || 'vimeo';
    var wrap = btn.closest('.video-card__wrap') || btn.closest('.videos-page-card__wrap');
    if (!wrap) return;

    var src;
    if (platform === 'youtube') {
      src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&modestbranding=1';
    } else {
      src = 'https://player.vimeo.com/video/' + videoId + '?title=0&byline=0&portrait=0&autoplay=1';
    }

    wrap.innerHTML = '<iframe src="' + src + '" style="position:absolute;inset:0;width:100%;height:100%;border:none;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; encrypted-media" allowfullscreen></iframe>';
  });
})();
